module.exports = "/static-assets/_next/static/images/walkToUnlock-5026d2f8eae29c8b495ee7291e1da67f.png";